import {FC, ReactElement} from 'react';
import classNames from 'classnames';

interface SpinnerProps {
  loadingText?: string,
  embedded?: boolean,
  isLoading?: boolean,
  children?: Nullable<ReactElement>
}

const Spinner: FC<SpinnerProps> = ({
  loadingText='',
  embedded=false,
  isLoading=true,
  children=null
}) => {
  const isSmall = embedded ? 'small-' : '';
  const isOverlaid = !!children;
  const spinnerComponent = (
    <div className={classNames(`${isSmall}spinner-container`, {'overlaid': isOverlaid})}>
      <div className={`${isSmall}spinner-and-text`}>
        <div className={`${isSmall}spinner`} />
        {loadingText && <p className="loading-text">{loadingText}</p>}
      </div>
    </div>
  );

  if (isOverlaid && isLoading) {
    return (
      <div className="spinner-relative-wrapper">
        {children}
        {spinnerComponent}
      </div>
    );
  } else if (isOverlaid && !isLoading) {
    return children;
  }

  return spinnerComponent;
};

export default Spinner;
